import React from "react";

const STATUS_CONFIG = {
  Draft: { className: "sxProjectStatus--draft", label: "DRAFT" },
  "In Progress": {
    className: "sxProjectStatus--progress",
    label: "IN PROGRESS",
  },
  Rendered: { className: "sxProjectStatus--rendered", label: "RENDERED" },
};

const ProjectStatusBadge = ({ status }) => {
  const config = STATUS_CONFIG[status] || STATUS_CONFIG.Draft;

  return (
    <span
      className={`sxProjectStatus ${config.className}`}
      aria-label={`Project status: ${config.label}`}
    >
      <span className="sxProjectStatus__dot" aria-hidden="true" />
      {config.label}
    </span>
  );
};

export default ProjectStatusBadge;
